require('!!raw-loader!/builds/930990/v2/src/index.html');